import * as authActions from 'app/auth/store/actions'
import PrimaryButton from 'app/components/buttons/PrimaryButton'
import ConfirmationDialog from 'app/components/ConfirmationDialog'
import { useIsPlaceRestricted } from 'commons/useIsPlaceRestricted'
import { useIsRootAdmin, useUserProfile } from 'commons/useUserProfile'
import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'

function NoticeRestrictedPlace() {
  const { formatMessage } = useIntl()
  const userData = useUserProfile()
  const [isOpenNoticePlanIsRestricted, setIsOpenNoticePlanIsRestricted] =
    React.useState(false)
  const isPlaceRestricted = useIsPlaceRestricted()
  const isRootAdmin = useIsRootAdmin()
  const dispatch = useDispatch()

  React.useEffect(() => {
    if (!isRootAdmin(userData.id) && isPlaceRestricted) {
      setIsOpenNoticePlanIsRestricted(true)
    }
  }, [isPlaceRestricted, isRootAdmin, userData.id])

  return (
    <ConfirmationDialog
      open={isOpenNoticePlanIsRestricted}
      title={formatMessage({
        id: 'permission.restricted.dialog.title',
      })}
      body={formatMessage({
        id: 'permission.restricted.alert.text',
      })}
      ConfirmButton={
        <PrimaryButton
          onClick={() => {
            dispatch(authActions.logoutUser())
            setIsOpenNoticePlanIsRestricted(false)
          }}
        >
          <FormattedMessage className="uppercase" id="action.ok" />
        </PrimaryButton>
      }
    />
  )
}

export default NoticeRestrictedPlace
